<template>
  <div class="container fluid">
    <template>
      <div class="mb-2">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 sm6>
            <v-btn
              depressed
              :outline="channelFilter != 'all'"
              :color="channelFilter == 'all' ? 'primary' : 'grey'"
              @click="channelFilter = 'all'"
              class="ma-0 mr-1 mb-1"
              >{{ $t('All') }}</v-btn
            >
            <v-btn
              depressed
              :outline="channelFilter != 'facebook'"
              :color="channelFilter == 'facebook' ? 'primary' : 'grey'"
              @click="channelFilter = 'facebook'"
              class="ma-0 mr-1 mb-1"
            >
              <em class="fab fa-facebook-square mr-1" />
              {{ $t('Facebook') }}
            </v-btn>
            <v-btn
              depressed
              :outline="channelFilter != 'line'"
              :color="channelFilter == 'line' ? 'primary' : 'grey'"
              @click="channelFilter = 'line'"
              class="ma-0 mr-1 mb-1"
            >
              <em class="fab fa-line mr-1" />
              {{ $t('Line') }}
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right"> </v-flex>
        </v-layout>
      </div>
      <div class="mb-2">
        <date-filter
          @changeDate="onChangeDate"
          :defaultFilter="'last_7_days'"
          v-model="selectedDate"
        ></date-filter>
      </div>
      <div class="mb-2">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 sm12 class="text-xs-right">
            <v-btn @click="onAddRedeemCode" class="primary">Add Redeem Code</v-btn>
            <v-btn @click="showsearch = true" class="primary"
              ><v-icon>search</v-icon> Advanced Search</v-btn
            >
          </v-flex>
          <v-flex xs12 sm9>
            <div>
              <v-pagination
                :total-visible="6"
                v-model="pageNumber"
                @input="changePage"
                :length="pagelength"
              ></v-pagination>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <v-data-table
        :headers="headers"
        :items="dataRedeemCode"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1 mt-4"
        :search="search"
      >
        <!-- hide-actions -->
        <template v-slot:items="props">
          <tr @click="showAllRedeemCode(props.item)" style="cursor: pointer">
            <td>{{ props.item.member_type }}</td>
            <td>{{ props.item.gift_type }}</td>
            <td>{{ props.item.product_name }}</td>
            <!-- <td>
              <a href="javascript:void(0);" @click="showAllRedeemCode(props.item)" >
                <em class="fas fa-ellipsis-h"/>
              </a>
            </td> -->
          </tr>
        </template>
      </v-data-table>
    </template>
    <div class="mt-2">
      <v-pagination
        :total-visible="6"
        v-model="pageNumber"
        @input="changePage"
        :length="pagelength"
      ></v-pagination>
    </div>

    <!-- Modal Search -->
    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn @click="showsearch = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Member Type') }}</label>
                <Multiselect
                  @input="$emit('change', $event)"
                  :placeholder="$t('Member Type')"
                  v-model="filter.memberType"
                  :options="categorylist"
                  label="name"
                ></Multiselect>
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Gift Type') }}</label>
                <Multiselect
                  @input="$emit('change', $event)"
                  :placeholder="$t('Gift Type')"
                  v-model="filter.giftType"
                  :options="subcategorylist"
                  label="name"
                ></Multiselect>
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Gift') }}</label>
                <Multiselect
                  @input="$emit('change', $event)"
                  :placeholder="$t('Gift')"
                  v-model="filter.gift"
                  :options="giftList"
                  label="name"
                ></Multiselect>
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
            <v-btn @click="onsearch" color="primary">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- Modal Import Redeem Code -->
    <v-dialog persistent width="600px" v-model="showModalImportRedeemCode">
      <v-card v-if="showModalImportRedeemCode">
        <ModalImportRedeemCode
          @close="showModalImportRedeemCode = false"
          @onImportCode="onImportCode"
        ></ModalImportRedeemCode>
      </v-card>
    </v-dialog>

    <!-- Modal Show All Code from Selected  -->
    <v-dialog persistent width="950px" v-model="showAllRedeemCodeModal">
      <v-card v-if="showAllRedeemCodeModal" class="pa-4">
        <ModalShowRedeemCode
          @close="showAllRedeemCodeModal = false"
          :selectedData="selectedRedeemCode"
        ></ModalShowRedeemCode>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import Multiselect from 'vue-multiselect'
import ModalImportRedeemCode from './ModalImportRedeemCode.vue'
import ModalShowRedeemCode from './ModalShowRedeemCode.vue'

export default {
  components: {
    ScaleLoader,
    exportxlsx,
    DateFilter,
    Multiselect,
    ModalImportRedeemCode,
    ModalShowRedeemCode
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: 'Member Level', value: 'member_level', sortable: true },
        { text: 'Gift Type', value: 'gift_type', sortable: true },
        { text: 'Gift', value: 'gift', sortable: false }
        // { text: '', value: '', sortable: false},
      ],
      dataRedeemCode: [],
      loading: false,
      orderModal: false,
      search: '',
      channelFilter: 'all',
      filter: {
        product: '',
        memberType: '',
        giftType: ''
      },

      selectedRedeemCode: null,
      showsearch: false,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },

      showModalImportRedeemCode: false,
      showAllRedeemCodeModal: false,
      type: '',
      categorylist: [],
      subcategorylist: [],
      giftList: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    pageid() {
      return this.selectedBot.pageid
    }
  },
  mounted() {
    var vm = this
    vm.getRedeemCode()
    vm.getCategories()
    vm.getSubCategories()
    vm.getGift()
  },

  methods: {
    getRedeemCode() {
      return new Promise((resolve) => {
        var vm = this
        var data = {
          pageid: vm.pageid, // required
          start_date: vm.selectedDate.start,
          end_date: vm.selectedDate.end
        }

        if (vm.filter.gift) {
          Object.assign(data, { product_id: vm.filter.gift.id })
        }

        if (vm.filter.giftType) {
          Object.assign(data, { gift_type: vm.filter.giftType.name })
        }

        if (vm.filter.memberType) {
          Object.assign(data, { member_type: vm.filter.memberType.name })
        }

        vm.loading = true
        api.getLamyRedeemCode(data, (err, response) => {
          if (response.responsecode == 200) {
            vm.dataRedeemCode = response.data
            vm.total = response.total
            vm.loading = false
            resolve(response.data)
          } else {
            console.log(err)
            return
          }
        })
      })
    },
    getAllCodes() {
      return new Promise((resolve) => {
        var vm = this
        var data = {
          pageid: vm.selectedBot.pageid,
          start_date: vm.selectedDate.start,
          end_date: vm.selectedDate.end
        }

        if (vm.filter.gift) {
          Object.assign(data, { product_id: vm.filter.gift.id })
        }

        if (vm.filter.giftType) {
          Object.assign(data, { gift_type: vm.filter.giftType.name })
        }

        if (vm.filter.memberType) {
          Object.assign(data, { member_type: vm.filter.memberType.name })
        }

        this.loading = true
        api.getLamyRedeemAllCodeById(data, (err, response) => {
          if (response.responsecode == 200) {
            resolve(response.data)
          } else {
            console.log(err)
            return
          }
        })
      })
    },
    getCategories() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        limit: vm.limit,
        offset: vm.offset
      }
      api.getLamyGiftCategory(data, function (error, response) {
        if (response.responsecode == 200) {
          vm.categorylist = response.data
        } else {
          console.error(error)
          return
        }
      })
    },
    getSubCategories() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        limit: vm.limit,
        offset: vm.offset
      }

      api.getLamyGiftSubCategory(data, function (error, response) {
        if (response.responsecode == 200) {
          vm.subcategorylist = response.data
        } else {
          console.error(error)
          return
        }
      })
    },
    getGift() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        limit: vm.limit,
        offset: vm.offset
      }

      api.getLamyGiftProducts(data, function (error, response) {
        if (response && response.responsecode == 200) {
          var giftOptions = []
          $.each(response.data, function (index, val) {
            giftOptions.push({ name: val.name, id: val.id })
          })

          vm.giftList = giftOptions
        } else {
          console.error(error)
          return
        }
      })
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    onAddRedeemCode() {
      this.type = 'add'
      this.showModalImportRedeemCode = true
    },
    showAllRedeemCode(item) {
      var vm = this
      vm.selectedRedeemCode = item
      vm.showAllRedeemCodeModal = true
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getRedeemCode()
      }
    },
    onsearch() {
      this.getRedeemCode()
      this.showsearch = false
    },
    clearsearch() {
      this.filter = {
        memberType: '',
        giftType: '',
        gift: ''
      }
      this.onsearch()
    },
    onChangeDate() {
      this.getRedeemCode()
    },
    onImportCode() {
      this.onsearch()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/RedeemCode.vue